
export interface AdminAccountRefundRequest {
  orderId: string;
  reason: string;
  userId: string;
}
